import script from "./PasswordReset.vue?vue&type=script&setup=true&lang=js"
export * from "./PasswordReset.vue?vue&type=script&setup=true&lang=js"

import "./PasswordReset.vue?vue&type=style&index=0&id=5d57df2d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d57df2d"]])

export default __exports__